<template>
    <label
  		class="full"
  	>

  		Indirizzo e n° civico
  		<input 
  			id="ship-address"
  			class="form-control"
  			placeholder=""
  			type="text"
  			v-model="subscriptionStore.subscriptionParams.street"
        @input="input"
  			@change="onchange"
  			@focus="reset"
      	/>

    <span v-if="subscriptionStore.subscriptionParams.longitude == null" :class="{'qtext-error': subscriptionStore.subscriptionParams.street}">
      Seleziona un indirizzo fornito dai risultati
    </span> 
  </label>
</template>

<script type="text/javascript">

import { subscriptionStore } from '../../store/subscriptionStore'

export default {
	data () {
		return {
			subscriptionStore: subscriptionStore.state
		}
	},

	props: {
		showAddressInput: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		filledAddress () {
			return this.subscriptionStore.subscriptionParams.street
		}
	},

	methods: {
		initAutocomplete() {
			if (!this.$root.config.googlePlaces) return
			// Create the autocomplete object, restricting the search predictions to
			// geographical location types.
			this.autocomplete = new google.maps.places.Autocomplete(
				document.getElementById('ship-address'), {
					types: [`address`],
					componentRestrictions: { country: "it" }
				}
			)

			// Avoid paying for data that you don't need by restricting the set of
			// place fields that are returned to just the address components.
			this.autocomplete.setFields(['address_component', 'geometry'])

			// When the user selects an address from the drop-down, populate the
			// address fields in the form.
			this.autocomplete.addListener('place_changed', this.fillInAddress)
		},

		fillInAddress() {
			if (!this.$root.config.googlePlaces) return

			// Get the place details from the autocomplete object.
			var place = this.autocomplete.getPlace()
			
			if (!place.address_components) return

			var number = place.address_components.find(r => r.types.includes('street_number'))
			var street = place.address_components.find(r => r.types.includes('route'))

			// var address = street && number ? street.long_name + ', ' + number.long_name : null
			this.$emit('update:isAddressCompleted', street && number ? true : false)

			var address = ''
			address = street ? address + street.long_name : address
			address = number ? address + ', ' + number.long_name : address

			var zip_code = null
			var zip = place.address_components.find(r => r.types.includes('postal_code'))
			if (zip) zip_code = zip.long_name

			var city = null
			var local = place.address_components.find(r => r.types.includes('locality'))
			if (local) city = local.long_name.toUpperCase()

			// var country_code = null
			// var country = place.address_components.find(r => r.types.includes('country'))
			// if (country) country_code = country.short_name

			subscriptionStore.updateSubscriptionParam({ param: 'street', value: address })

			subscriptionStore.updateSubscriptionParam({ param: 'zip_code', value: zip_code })
			subscriptionStore.updateSubscriptionParam({ param: 'city', value: city })
			subscriptionStore.updateSubscriptionParam({ param: 'latitude', value: parseFloat(place.geometry.location.lat().toFixed(6))})
			subscriptionStore.updateSubscriptionParam({ param: 'longitude', value: parseFloat(place.geometry.location.lng().toFixed(6))})
	
			// subscriptionStore.updateSubscriptionParam({ param: 'country', value: country_code })

			this.$emit('update:showAddressInput', false)
			/* document.getElementById('autocomplete').value = null */
		},

    input (value) {
      subscriptionStore.updateSubscriptionParam({ param: 'latitude', value: null })
      subscriptionStore.updateSubscriptionParam({ param: 'longitude', value: null })
    },

		onchange() {
			subscriptionStore.updateSubscriptionParam({ param: 'street', value: document.getElementById("ship-address").value })
			this.reset()
		},

		reset() {
			document.getElementById("ship-address").setAttribute("autocomplete", "new-password")
		}
	},

	mounted () {
		this.initAutocomplete()
	},

	created() {
		
	}
}

</script>

<style scoped>
	label {
		position: relative;
	}

	.fa-search {
		position: absolute;
		bottom: 20px;
		left: 15px;
		color: #ededed;
	}
</style>